import { HmModelRest } from './abstract_model';
import { RuoliUtente, AutorizzazioneOperatore } from './utente';
import { Distretto } from './anagrafica_geo';

export class TeamOperatoreDistretto extends HmModelRest {
    static readonly rest_path = 'team_operatori_distretti';

    id: number;
    nome: string;
    cognome?: string;

    role: RuoliUtente;
    email?: string;
    cod_fiscale: string;
    distretto?: number; // | Distretto;
    operatore_can?: boolean;
}

export interface AssocOperatoriAuth {
    team_operatore: TeamOperatoreDistretto;
    autorizzazione: AutorizzazioneOperatore;
}

export interface OperatoreDistretto {
    id: number;
    Operatore: Operatore;
    user_nominativo: string;
}

export interface Operatore {
    username: string;
    role: string;
}